import * as React from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { useDispatch } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import { prefillShippingForms } from '../actions.js';

const useFormPrefill = (userData)=>{
    const checkoutSettings = useCheckoutSettings();
    const shippingDetailsCart = checkoutSettings.shippingDetails;
    const dispatch = useDispatch();
    const { loading , called  } = Context.useCart();
    React.useEffect(()=>{
        if (called && !loading && userData.status !== 'loading') {
            dispatch(prefillShippingForms({
                userData,
                cartData: shippingDetailsCart,
                fields: checkoutSettings.shippingFormFields
            }));
        }
    // We don't want this effect to trigger every time the shippingDetailsCart is updated,
    // only once when the forms are ready
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        loading,
        called,
        shippingDetailsCart,
        userData.status
    ]);
};

export { useFormPrefill };
//# sourceMappingURL=use-form-prefill.js.map
